<template>
    <el-row type="flex" class="row-bg" justify="center">
        <el-col :span="24">
            <el-card>
                <img :src="headImage.picture" class="image"/>
            </el-card>
        </el-col>
    </el-row>
</template>

<script>

    import auth from '../api/userauth';
    import wxConfig from "../api/wxconfig";

    let globalId = '';
    export default {
        data() {
            return {
                headImage: {
                    picture: ''

                }
            }
        },
        methods: {},
        created() {
            //this.headImage.picture = "http://mpc.sinosoftweixin.com/api/robot/image/944";

            //  alert('create');
            let userstr = sessionStorage.getItem("user");
            // prompt('userstr;'+userstr,userstr);
            //  userstr="{\"userId\":\"944\",\"name\":\"佟盟\",\"gender\":\"1\"}";
            let user;
            let that = this;
            if (userstr != null && userstr != '{}') {
                // alert('has');
                user = JSON.parse(userstr);
                let userId = user.userId;

                that.headImage.picture = "http://mpc.sinosoftweixin.com/api/robot/image/" + userId;


            } else {
                // alert(' don`t has');

                auth.getCode().then(res => {

                    let data = JSON.stringify(res.data);
                    //alert('data:'+data)
                    if (data != '{}') {
                        sessionStorage.setItem('user', data);
                        let user = JSON.parse(sessionStorage.getItem("user"));
                        let userId = user.userId;
                        //alert('success:' + userId);
                        // console.log("userId:"+userId)


                        that.headImage.picture = "http://mpc.sinosoftweixin.com/api/robot/image/" + userId;

                        wxConfig.wxConfig(user)
                        // this.getPersonList()
                        // let winHeight = document.documentElement.clientHeight                          //视口大小
                        //document.getElementById('container').style.height = (winHeight - 49) +'px'  //调整上拉加载框高度
                    } else {
                        this.$message({
                            message: "请在企业微信中打开该页面 ",
                            type: 'error'
                        });
                        this.errorHtml = '<div class="el-loading-mask is-fullscreen" style="background-color: rgba(0, 0, 0, 0.7); z-index: 2000;"><div class="el-loading-spinner"><i class="el-icon-loading"></i><p class="el-loading-text">打开此链接的用户,我们很抱歉的通知您,您没有访问此页面的权限</p></div></div>';
                    }


                })
            }


        }, mounted() {
            document.title = '头像拼图';
            //  if (window.history && window.history.pushState) {
            //      history.pushState(null, null, documen
            //
            //      .0233.2
            //      3is.goBack, false);
            //  }


        }, destroyed() {
            // window.removeEventListener('popstate', this.goBack, false);
            //window.removeEventListener('beforeunload', this.goBack, false);

        }
    }


</script>

<style>
    .el-row {
        margin-bottom: 20px;
    }

    .el-col {
        border-radius: 4px;
    }

    .bg-purple-dark {
        background: #99a9bf;
    }

    .bg-purple {
        background: #d3dce6;
    }

    .bg-purple-light {
        background: #e5e9f2;
    }

    .row-bg {
        padding: 10px 0;
        background-color: #f9fafc;
    }


    .content {
        text-align: left;
        font-size: 18px;
        background: #e5e9f2;

    }

    .el-button {
        font-size: 12px;
    }

    .time {
        font-size: 13px;
        color: #999;
    }

    .bottom {
        margin-top: 13px;
        line-height: 12px;
    }

    .button {
        padding: 0;
        float: right;
    }

    .image {
        width: 95%;
        display: block;
        margin: auto;
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }

    .clearfix:after {
        clear: both
    }

</style>
